module.exports = __webpack_public_path__ + "img/Group 208.a9876478.svg";